import { render, staticRenderFns } from "./SearchDateWidget.vue?vue&type=template&id=66a375c8&"
import script from "./SearchDateWidget.vue?vue&type=script&lang=js&"
export * from "./SearchDateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports